export const getDayjsDateFormat = (pref, options = {}) => {
  const {
    month = 'short',
  } = options;

  const monthFormat = {
    short: 'MMM',
    long: 'MMMM',
  }[month] || 'MMM';

  switch ((pref || '').toLowerCase()) {
    case 'mm/dd/yyyy':
      return `${monthFormat} D, YYYY`;
    case 'dd/mm/yyyy':
      return `D ${monthFormat}, YYYY`;
    case 'yyyy/mm/dd':
      return `YYYY ${monthFormat} D`;
    default:
      return `${monthFormat} D, YYYY`;
  }
};
